<template>
    <div v-if="is_socket_opened">
        <el-dialog
                title="选择置顶时间"
                :visible.sync="dialogVisible"
                :width="is_mobile?'80%':'30%'"
        >
            <button class="dialog_btn" data-time="1" @click="click_dialog_btn($event)">1分钟</button>
            <button class="dialog_btn" data-time="3" @click="click_dialog_btn($event)">3分钟</button>
            <button class="dialog_btn" data-time="5" @click="click_dialog_btn($event)">5分钟</button>
            <button class="dialog_btn" data-time="10" @click="click_dialog_btn($event)">10分钟</button>
            <button class="dialog_btn" data-time="30" @click="click_dialog_btn($event)">30分钟</button>
            <button class="dialog_btn" data-time="-1" @click="click_dialog_btn($event)">永 久</button>
            <button class="dialog_btn" data-time="0" @click="click_dialog_btn($event)">取 消</button>
        </el-dialog>
        <el-dialog
                title="修改信息内容"
                :visible.sync="messageDialogVisible"
                :width="is_mobile?'80%':'50%'"
                id="change_message_dialog"
        >
            <textarea maxlength="1000" class="dialog_text" v-model="temp_change_message"></textarea>
            <button class="dialog_btn" @click="change_message_dialog_btn()">确认修改</button>
        </el-dialog>
        <el-dialog
                title="修改主题名称"
                :visible.sync="subjectNameDialogVisible"
                :width="is_mobile?'80%':'50%'"
        >
            <textarea maxlength="1000" class="dialog_text" v-model="temp_subject_name"></textarea>
            <button class="dialog_btn" @click="subject_name_dialog_btn()">确认修改</button>
        </el-dialog>
        <el-dialog
                title="修改主题内容"
                :visible.sync="subjectContentDialogVisible"
                :width="is_mobile?'80%':'50%'"
        >
            <textarea maxlength="1000" class="dialog_text" v-model="temp_subject_content"></textarea>
            <button class="dialog_btn" @click="subject_content_dialog_btn()">确认修改</button>
        </el-dialog>
        <el-dialog
                title="在线列表"
                :visible.sync="usersDialogVisible"
                :width="is_mobile?'80%':'50%'"
        >
            <div style="max-height:500px;overflow-y:scroll;background-color: #ede8f0; margin-left: 10px">
                <div v-for="(user, index_user) in all_user"
                    :key="index_user" style="float: left; background-color: #feffd9; margin-right: 10px">
                    <b>{{user['name']}}</b>
                    <img class="avatar" :src="user['avatar_url']">
                    <el-link v-if="!user['forbidden']" type="primary" @click="set_user_forbidden(user)">禁言</el-link>
                    <el-link v-else type="primary" @click="set_user_forbidden(user)">解除禁言</el-link>
                </div>
            </div>
            <button class="dialog_btn" @click="usersDialogVisible=false">关闭</button>
        </el-dialog>
        <el-dialog
          title="提示"
          :visible.sync="deleteDialogVisible"
          width="30%">
          <span>是否删除该内容为：“{{delete_message_info['message']}}”的信息？</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="deleteDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="delete_up_message_comfirm()">确 定</el-button>
          </span>
        </el-dialog>
        <div v-if="is_mobile">
            <meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=no">
            <el-tabs type="border-card">
                <el-tab-pane v-if="is_teacher">
                    <span slot="label">主题</span>
                    <div class="show_flex" :style="screen_height_mobile">
                        <div v-if="is_teacher" style="width: 100%;margin-left: 20px;margin-right: 20px;background-color: #fff;border-radius: 6px ">
                            <div class="tpl-left-nav tpl-left-nav-hover" style="display: block; width: 100%">
                                <div class="tpl-left-nav-menu-sy-mobile" v-for="subject in symposium_subject" :key="subject['id']">
                                    <div class="tpl-left-nav-split"/>
                                    <div class="tpl-left-nav-title"
                                         style="min-height: 24px;padding: 8px 15px 10px;color: #3B200C;font-size: 14px;font-weight: 400;">
                                        <a class="nav-link" @click="change_subject(subject)"
                                           :class="subject['outer_id'] === active_page.subject_outer_id ? 'router-link-active':''">
                                            <span>{{subject.name}}</span>
                                        </a>
                                        <!--{{subject.name}}-->
                                    </div>
                                    <!--<div class="tpl-left-nav-list" style="width: 100%">-->
                                        <!--<ul class="tpl-left-nav-menu">-->
                                            <!--<div class="tpl-left-nav-split"/>-->
                                            <!--<li class="tpl-left-nav-item" v-for="page in subject.pages" :key="page['id']">-->
                                                <!--<a class="nav-link" :class="page.id == active_page.id ? 'router-link-active':''"-->
                                                   <!--@click="is_teacher?change_active_page(page):''">-->
                                                    <!--<i class="fa"></i>-->
                                                    <!--<span>{{page.name}}</span>-->
                                                <!--</a>-->
                                            <!--</li>-->
                                        <!--</ul>-->
                                    <!--</div>-->
                                </div>
                                <div class="tpl-left-nav-split"/>
                            </div>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane>
                    <span slot="label">置顶消息</span>
                    <div class="center_area_mobile" :style="screen_height_mobile">
                        <!--background-color: #89d7ff;-->
                        <div style="margin-bottom: 5px">
                            <!--<textarea :class="is_teacher?'':'not_show'" style="width: 80%;height: 20px" :value="active_page.content" @change="subject_content_change($event)"/>-->
                            <a href="#" @click="click_quit"> {{ course_name }}</a>
                        </div>
                        <div style="margin-bottom: 5px">
                            <!--<input :class="is_teacher?'':'not_show'" :value="active_page.subject_name" @change="subject_name_change($event)"/>-->
                            <b @click="is_teacher?change_subject_name_dialog_on():''"><i v-if="is_teacher" class="fa fa-pencil" aria-hidden="true"></i> {{ active_page.subject_name }}</b>
                            <a :class="is_teacher?'el-icon-circle-plus-outline':'not_show'" @click="add_page"
                               style="float: right;font-size: 24px;color:#3B200C"></a>
                        </div>
                        <div style="margin-bottom: 5px;border-bottom: 1px solid #eee; ">
                            <!--<textarea :class="is_teacher?'':'not_show'" style="width: 80%;height: 20px" :value="active_page.content" @change="subject_content_change($event)"/>-->
                            <p @click="is_teacher?change_subject_content_dialog_on():''"><i v-if="is_teacher" class="fa fa-pencil" aria-hidden="true"></i> {{ active_page.content }}</p>
                        </div>
                        <ul id="root_center" v-if="show_type==='微信模式'">
                            <li class="item significant_kanban" :style="m_index%2===1?'background: #fff;':'background: #eee;'" v-for="(message, m_index ) in all_up_message" :key="m_index">
                                <!--<div v-if="message['user']['id'] === user_info['id']">-->
                                    <!--<div class="item_header_self">-->
                                        <!--<img class="avatar" :src="message['user']['avatar_url']">-->
                                        <!--<span >{{message.user.name}}</span>-->
                                        <!--&lt;!&ndash;<span>{{message.up_time}}</span>&ndash;&gt;-->
                                    <!--</div>-->
                                    <!--<div class="item_content_self_mobile">-->
                                        <!--<div @click="is_teacher?change_message_dialog_on(message):''">-->
                                            <!--<img class="item_side_img_right" :src="right_img">-->
                                            <!--{{message.message}}-->
                                        <!--</div>-->

                                        <!--&lt;!&ndash;<a @click="delete_up_message(message.id)" class="el-icon-close item_close"></a>&ndash;&gt;-->
                                        <!--<div class="item_up_down_div_self">-->
                                            <!--<span class="item_up">-->
                                                <!--<a @click="support_up_message(message)" class="far fa-thumbs-up"></a>{{message.support_count}}-->
                                            <!--</span>-->
                                            <!--<span class="item_down">-->
                                                <!--<a @click="stamp_up_message(message)" class="far fa-thumbs-down"></a>{{message.stamp_count}}-->
                                            <!--</span>-->
                                        <!--</div>-->
                                    <!--</div>-->

                                    <!--<el-popconfirm class="not_show" title="这是一段内容确定删除吗？" @onConfirm="delete_up_message(message)">-->
                                        <!--<el-button slot="reference" class="item_close el-dateSet" style="padding: 0;border: none"><i class="el-icon-close"></i></el-button>-->
                                    <!--</el-popconfirm>-->
                                <!--</div>-->
                                <div>
                                    <div class="item_header">
                                        <img class="avatar" :src="message['user']['avatar_url']">
                                        <span v-if="message.user.name.length <= 5">{{message.user.name}}</span>
                                        <span v-else>{{message.user.name.substring(0,5)}}...</span>
                                    </div>
                                    <div class="message_center_left_mobile">
                                        <div @click="is_teacher?change_message_dialog_on(message):''" style="float: left" :style="user_info.teacher.includes(Number(message['user']['id']))?'font-weight: bolder;color:#3B200C':'color:#3B200C'">
                                            {{message.message}}
                                        </div>
                                        <!--<a @click="delete_up_message(message.id)" class="el-icon-close item_close"></a>-->
                                        <div class="item_up_down_div" :style="center_button_flow_left_mobile">
                                            <span class="item_up">
                                                <a @click="support_up_message(message)" class="far fa-thumbs-up"></a>{{message.support_count}}
                                            </span>
                                            <span class="item_down">
                                                <a @click="stamp_up_message(message)" class="far fa-thumbs-down"></a>{{message.stamp_count}}
                                            </span>
                                        </div>
                                    </div>

                                    <el-popconfirm v-if="is_teacher" title="这是一段内容确定删除吗？" @onConfirm="delete_up_message(message)">
                                        <el-button slot="reference" class="item_close_mobile el-dateSet" style="padding: 0;border: none"><i class="el-icon-close"></i></el-button>
                                    </el-popconfirm>
                                </div>
                            </li>
                        </ul>
                    </div>
                </el-tab-pane>
                <el-tab-pane>
                    <span slot="label">讨论消息</span>
                    <div class="right_area_mobile" :style="screen_height_mobile">
                        <div style="height: 78%">
                            <div class="right_top_div">
                                <span>在线人数：{{all_user.length}}</span>
                                <!--<select v-model="show_type" @change="show_type_change()">-->
                                    <!--<option v-for="item in show_types"-->
                                            <!--:key="item['key']"-->
                                            <!--:value="item['value']">-->
                                        <!--{{item['value']}}-->
                                    <!--</option>-->
                                <!--</select>-->
                                <span v-if="is_connected"
                                      style="float: right;margin-left: 10px;color: rgb(89, 207, 74)">在线</span>
                                <span v-else style="float: right;margin-left: 10px;margin-top: 2px;color: rgb(255, 197, 0);">离线</span>
                                <el-link style="float: right;margin-left: 10px;color:red;margin-top: 2px;" @click="click_quit">退出</el-link>
                                <span v-if="is_symposium_opened" style="float: right;margin-left: 10px;margin-top: 2px;color:#3B200C;">已开课</span>
                                <span v-else style="float: right;margin-left: 10px;color:red;margin-top: 2px;">未开课</span>
                                <span v-if="is_teacher" style="float: right;">
                                    <el-link style="color:#3B200C" v-if="is_symposium_opened" type="primary" @click="start_or_end_symposium('end')">下课</el-link>

                                    <!--<el-link style="color:#3B200C" v-if="is_symposium_opened" type="primary" @click="start_or_end_symposium('end')">下课</el-link>-->
                                    <el-link style="color:#3B200C" v-if="!is_symposium_opened" type="primary" @click="start_or_end_symposium('start')">上课</el-link>
                                </span>
                                <span v-if="is_teacher" style="float: right;margin-right: 10px;">
                                      <el-link style="color:#3B200C" type="primary" @click="usersDialogVisible=true">学员管理</el-link>
                                </span>


                            </div>
                            <!--<div :class="is_teacher?'right_top_div':'not_show'">-->
                            <!--在线人数：{{all_user.length}}-->
                            <!--</div>-->
                            <ul class="top_box">
                                <li class="top_message" v-for="(raise_info, raise_index) in all_raise" :key="raise_index" :title="raise_info['message']">
                                    <!--<b>{{raise_info['time']}}</b>-->
                                    <img class="avatar"
                                         :src="raise_info['user_info']['avatar_url']">
                                    <b>{{ raise_info['user_info']['name'] }} ： {{raise_info['title']}}</b>
                                    <b style="float: right" v-if="all_raise_left_time && all_raise_left_time[raise_index]">{{ get_time_left(all_raise_left_time[raise_index]) }}</b>
                                    <i :class="is_teacher?'el-icon-close top_message_item_close':'not_show'" @click="delete_raise_message(raise_info)"></i>
                                </li>
                            </ul>
                            <ul class="message_box" id="scroll_div">
                                <li class="item significant_kanban" v-for="message in all_words" :key="message.id">
                                    <div v-if="message['user_info']['user_id'] === user_info['id']">
                                        <div class="item_header_self">
                                            <img class="avatar" :src="message['user_info']['avatar_url']">
                                            <span style="text-align: center" v-if="message['user_info']['name'].length <= 5">{{message['user_info']['name']}}</span>
                                            <span style="text-align: center" v-else>{{message['user_info']['name'].substring(0,5)}}...</span>
                                            <!--<span>{{message.up_time}}</span>-->
                                        </div>
                                        <div class="item_content_self">
                                            <div>
                                                <img class="item_side_img_right" :src="right_img">
                                                <button :class="is_teacher?'raise_btn':'not_show'" :data-outer-id="message['outer_id']"
                                                        @click="click_raise_btn($event)">
                                                    置顶
                                                </button>
                                                {{message.message}}
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <div class="item_header">
                                            <img class="avatar" :src="message['user_info']['avatar_url']">
                                            <span style="text-align: center" v-if="message['user_info']['name'].length <= 5">{{message['user_info']['name']}}</span>
                                            <span style="text-align: center" v-else>{{message['user_info']['name'].substring(0,5)}}...</span>
                                            <!--<span>{{message.up_time}}</span>-->
                                        </div>
                                        <div class="item_content"  :style="user_info.teacher.includes(Number(message['user_info']['user_id']))?'font-weight: bolder;color:#3B200C':'color:#3B200C'">
                                            <div>
                                                <img class="item_side_img" :src="left_img">
                                                {{message.message}}
                                                <!--<button :class="is_teacher?'raise_btn':'not_show'" :data-outer-id="info['outer_id']"-->
                                                        <!--@click="click_raise_btn($event)">-->
                                                    <!--置顶-->
                                                <!--</button>-->
                                                <button :class="is_teacher?'raise_btn':'not_show'" :data-outer-id="message['outer_id']"
                                                        @click="click_raise_btn($event)">
                                                    置顶
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                                <!--<li class="message" v-for="(info, index) in all_words"-->
                                    <!--:key="index">-->
                                    <!--&lt;!&ndash;<b>{{info['time']}}</b>&ndash;&gt;-->
                                    <!--<img class="avatar" :src="info['user_info']['avatar_url']">-->
                                    <!--<b>{{ info['user_info']['name'] }} ： {{info['message']}}</b>-->
                                    <!--<button :class="is_teacher?'raise_btn':'not_show'" :data-outer-id="info['outer_id']"-->
                                            <!--@click="click_raise_btn($event)">-->
                                        <!--置顶-->
                                    <!--</button>-->
                                <!--</li>-->
                            </ul>
                        </div>

                        <div :class="forbidden?'not_show':'input_area'">
                            <textarea placeholder="请在此输入..." placeholder-class="place-holder" maxlength="1000" v-if="is_symposium_opened" class="test_area" v-model="inputting_words"
                                  v-on:keyup.13="websocketsend()"></textarea>
                            <textarea v-else class="test_area" v-model="inputting_words"></textarea>
                            <!--<input type="text" class="form-control" v-model="inputting_words">-->
                            <button v-if="(is_symposium_opened && !forbidden)|| is_teacher" class="btn_sym" @click="websocketsend()">
                                发送
                            </button>
                        </div>
                        <div :class="forbidden?'input_area':'not_show'">
                            <p style="color: red">您已被管理员禁言</p>
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
        <div v-else>

            <div style="display: flex" :style="screen_height">
                <div v-if="is_teacher" style="width: 9%;margin-left: 20px;margin-right: 20px;background-color: #fff;border-radius: 6px ">
                    <div class="tpl-left-nav tpl-left-nav-hover" style="display: block; width: 100%">
                        <div class="tpl-left-nav-menu-sy" v-for="subject in symposium_subject" :key="subject['id']">
                            <div class="tpl-left-nav-split"/>
                            <div class="tpl-left-nav-title"
                                 style="min-height: 24px;padding: 8px 15px 10px;color: #3B200C;font-size: 14px;font-weight: 400;">
                                <a class="nav-link" @click="change_subject(subject)"
                                   :class="subject['outer_id'] === active_page.subject_outer_id ? 'router-link-active':''">
                                    <span>{{subject.name}}</span>
                                </a>
                                <!--{{subject.name}}-->
                            </div>
                            <!--<div class="tpl-left-nav-list" style="width: 100%">-->
                                <!--<ul class="tpl-left-nav-menu">-->
                                    <!--<div class="tpl-left-nav-split"/>-->
                                    <!--<li class="tpl-left-nav-item" v-for="page in subject.pages" :key="page['id']">-->
                                        <!--<a class="nav-link" :class="page.id == active_page.id ? 'router-link-active':''"-->
                                           <!--@click="is_teacher?change_active_page(page):''">-->
                                            <!--<i class="fa"></i>-->
                                            <!--<span>{{page.name}}</span>-->
                                        <!--</a>-->
                                    <!--</li>-->
                                <!--</ul>-->
                            <!--</div>-->
                        </div>
                        <div class="tpl-left-nav-split"/>
                    </div>
                </div>
                <div :class="is_teacher?'center_area':'center_area_not_teacher'">
                    <!--background-color: #89d7ff;-->
                    <div style="margin-bottom: 5px">
                        <!--<textarea :class="is_teacher?'':'not_show'" style="width: 80%;height: 20px" :value="active_page.content" @change="subject_content_change($event)"/>-->
                        <a href="#" @click="click_quit"> {{ course_name }}</a>
                    </div>
                    <div style="margin-bottom: 5px">
                        <!--<input :class="is_teacher?'':'not_show'" :value="active_page.subject_name" @change="subject_name_change($event)"/>-->
                        <b style="cursor: pointer" @click="is_teacher?change_subject_name_dialog_on():''"><i v-if="is_teacher" class="fa fa-pencil" aria-hidden="true"></i> {{ active_page.subject_name }}</b>
                        <a :class="is_teacher?'el-icon-circle-plus-outline':'not_show'" @click="add_page"
                           style="float: right;font-size: 24px;color:#3B200C"></a>
                    </div>
                    <div style="margin-bottom: 5px;border-bottom: 1px solid #DE8100; ">
                        <!--<textarea :class="is_teacher?'':'not_show'" style="width: 80%;height: 20px" :value="active_page.content" @change="subject_content_change($event)"/>-->
                        <p style="cursor: pointer" @click="is_teacher?change_subject_content_dialog_on():''"><i v-if="is_teacher" class="fa fa-pencil" aria-hidden="true"></i> {{ active_page.content }}</p>
                    </div>
                    <!--<li class="message" v-for="(info, index) in all_words"-->
                        <!--:key="index">-->
                        <!--&lt;!&ndash;<b>{{info['time']}}</b>&ndash;&gt;-->
                        <!--<img class="avatar" :src="info['user_info']['avatar_url']">-->
                        <!--<b>{{ info['user_info']['name'] }} ： {{info['message']}}</b>-->
                        <!--<button :class="is_teacher?'raise_btn':'not_show'" :data-outer-id="info['outer_id']"-->
                                <!--@click="click_raise_btn($event)">-->
                            <!--置顶-->
                        <!--</button>-->
                    <!--</li>-->
                    <ul id="root_center" v-if="show_type==='微信模式'">
                        <li class="item_center significant_kanban" :style="m_index%2===1?'background: #fff;':'background: #eee;'" v-for="(message, m_index) in all_up_message" :key="m_index"
                         @mousedown="is_teacher?up_message_on_mouse_down($event,message):''" @mousemove="is_teacher?up_message_on_mouse_move():''" @mouseup="is_teacher?up_message_on_mouse_up():''">
                            <!--<div v-if="message['user']['id'] === user_info['id']">-->
                                <!--<div class="item_header_self">-->
                                    <!--<img class="avatar" :src="message['user']['avatar_url']">-->
                                    <!--<span class="margin-right-10">{{message.user.name}}</span>-->
                                    <!--&lt;!&ndash;<span>{{message.up_time}}</span>&ndash;&gt;-->
                                <!--</div>-->
                                <!--<div class="message_center_right">-->
                                    <!--<div @click="is_teacher?change_message_dialog_on(message):''">-->
                                        <!--{{message.message}}-->
                                    <!--</div>-->

                                    <!--&lt;!&ndash;<a @click="delete_up_message(message.id)" class="el-icon-close item_close"></a>&ndash;&gt;-->
                                    <!--<div class="item_up_down_div_self">-->
                                        <!--<span class="item_up">-->
                                            <!--<a @click="support_up_message(message)" class="far fa-thumbs-up"></a>{{message.support_count}}-->
                                        <!--</span>-->
                                        <!--<span class="item_down">-->
                                            <!--<a @click="stamp_up_message(message)" class="far fa-thumbs-down"></a>{{message.stamp_count}}-->
                                        <!--</span>-->
                                    <!--</div>-->
                                <!--</div>-->

                                <!--<el-popconfirm class="not_show" title="这是一段内容确定删除吗？" @onConfirm="delete_up_message(message)">-->
                                    <!--<el-button slot="reference" class="item_close el-dateSet" style="padding: 0;border: none"><i class="el-icon-close"></i></el-button>-->
                                <!--</el-popconfirm>-->
                            <!--</div>-->
                            <div>
                                <div class="item_header">
                                    <img class="avatar" :src="message['user']['avatar_url']">
                                    <span v-if="message.user.name.length <= 5">{{message.user.name}}</span>
                                    <span v-else>{{message.user.name.substring(0,5)}}...</span>
                                    <!--<span>{{message.up_time}}</span>-->
                                </div>
                                <div class="message_center_left">
                                    <div @click="is_teacher?change_message_dialog_on(message):''" style="cursor: pointer;float: left" :style="user_info.teacher.includes(Number(message['user']['id']))?'font-weight: bolder;color:#3B200C':'color:#3B200C'">
                                        {{message.message}}
                                    </div>
                                    <!--<a @click="delete_up_message(message.id)" class="el-icon-close item_close"></a>-->
                                    <div class="item_up_down_div" :style="center_button_flow_left">
                                        <span class="item_up">
                                            <a @click="support_up_message(message)" class="far fa-thumbs-up"></a>{{message.support_count}}
                                        </span>
                                        <span class="item_down">
                                            <a @click="stamp_up_message(message)" class="far fa-thumbs-down"></a>{{message.stamp_count}}
                                        </span>
                                    </div>
                                </div>

                                <!--<el-popconfirm class="not_show" title="这是一段内容确定删除吗？" @onConfirm="delete_up_message(message)">-->
                                    <!--<el-button slot="reference" class="item_close el-dateSet" style="padding: 0;border: none"><i class="el-icon-close"></i></el-button>-->
                                <!--</el-popconfirm>-->
                            </div>
                        </li>
                    </ul>
                    <ul id="root" v-else-if="show_type==='看板模式'" @dragover.prevent @drop="drop($event)">
                        <div class="item_kanban significant_kanban" v-for="message in all_up_message" :key="message.id" :title="message.message"
                            draggable="true" @dragstart="drag_test($event)" :data-o-id="message['outer_id']"
                        >
                            <div class="item_content_kanban">
                                <span @click="is_teacher?change_message_dialog_on(message):''">{{message.title}}</span>
                                <el-popconfirm :class="is_teacher?'':'not_show'" title="这是一段内容确定删除吗？" @onConfirm="delete_up_message(message)">
                                    <el-button slot="reference" class="item_close el-dateSet"
                                               style="padding: 0;border: none"><i class="el-icon-close"></i></el-button>
                                </el-popconfirm>
                                <!--<a @click="delete_up_message(message.id)" class="el-icon-close item_close"></a>-->
                            </div>
                            <div>
                                <span class="margin-right-10">{{message.user.name}}</span>
                                <span>{{message.up_time}}</span>
                            </div>
                            <span class="item_up_kanban">
                                    <a @click="support_up_message(message)" class="far fa-thumbs-up"></a>{{message.support_count}}
                            </span>
                            <span class="item_down_kanban">
                                    <a @click="stamp_up_message(message)" class="far fa-thumbs-down"></a>{{message.stamp_count}}
                            </span>
                        </div>
                    </ul>
                </div>
                <div class="right_area">
                    <div style="height: 78%">
                        <div class="right_top_div">
                            <span>在线人数：{{all_user.length}}</span>
                            <!--<select v-model="show_type" @change="show_type_change()">-->
                                <!--<option v-for="item in show_types"-->
                                        <!--:key="item['key']"-->
                                        <!--:value="item['value']">-->
                                    <!--{{item['value']}}-->
                                <!--</option>-->
                            <!--</select>-->
                            <span v-if="is_connected"
                                  style="float: right;margin-left: 10px;color: rgb(89, 207, 74)">在线</span>
                            <span v-else style="float: right;margin-left: 10px;margin-top: 2px;color: rgb(255, 197, 0);">离线</span>
                            <el-link style="float: right;margin-left: 10px;color:red;margin-top: 2px;" @click="click_quit">退出</el-link>
                            <span v-if="is_symposium_opened" style="float: right;margin-left: 10px;margin-top: 2px;color:#3B200C;">已开课</span>
                            <span v-else style="float: right;margin-left: 10px;color:red;margin-top: 2px;">未开课</span>
                            <span v-if="is_teacher" style="float: right;">
                                <el-link style="color:#3B200C" v-if="is_symposium_opened" type="primary" @click="start_or_end_symposium('end')">下课</el-link>

                                <!--<el-link style="color:#3B200C" v-if="is_symposium_opened" type="primary" @click="start_or_end_symposium('end')">下课</el-link>-->
                                <el-link style="color:#3B200C" v-if="!is_symposium_opened" type="primary" @click="start_or_end_symposium('start')">上课</el-link>
                            </span>
                            <span v-if="is_teacher" style="float: right;margin-right: 10px;">
                                  <el-link style="color:#3B200C" type="primary" @click="usersDialogVisible=true">学员管理</el-link>
                            </span>


                        </div>
                        <!--<div :class="is_teacher?'right_top_div':'not_show'">-->
                        <!--在线人数：{{all_user.length}}-->
                        <!--</div>-->
                        <ul class="top_box">
                            <li class="top_message" v-for="(raise_info, raise_index) in all_raise" :key="raise_index" :title="raise_info['message']">
                                <!--<b>{{raise_info['time']}}</b>-->
                                <img class="avatar"
                                     :src="raise_info['user_info']['avatar_url']">
                                <b>{{ raise_info['user_info']['name'] }} ： {{raise_info['title']}}</b>
                                <b style="float: right" v-if="all_raise_left_time && all_raise_left_time[raise_index]">{{ get_time_left(all_raise_left_time[raise_index]) }}</b>
                                <i :class="is_teacher?'el-icon-close top_message_item_close':'not_show'" @click="delete_raise_message(raise_info)"></i>
                            </li>
                        </ul>
                        <!--<ul class="message_box" id="scroll_div">-->
                            <!--<li class="message" v-for="(info, index) in all_words"-->
                                <!--:key="index">-->
                                <!--&lt;!&ndash;<b>{{info['time']}}</b>&ndash;&gt;-->
                                <!--<img class="avatar" :src="info['user_info']['avatar_url']">-->
                                <!--<b>{{ info['user_info']['name'] }} ： {{info['message']}}</b>-->
                                <!--<button :class="is_teacher?'raise_btn':'not_show'" :data-outer-id="info['outer_id']"-->
                                        <!--@click="click_raise_btn($event)">-->
                                    <!--置顶-->
                                <!--</button>-->
                            <!--</li>-->
                        <!--</ul>-->
                        <ul id="scroll_div" class="message_box">
                            <li class="item significant_kanban" v-for="message in all_words" :key="message.id">
                                <div v-if="message['user_info']['user_id'] === user_info['id']">
                                    <div class="item_header_self">
                                        <img class="avatar" :src="message['user_info']['avatar_url']">
                                        <span style="text-align: center" v-if="message['user_info']['name'].length <= 5">{{message['user_info']['name']}}</span>
                                        <span style="text-align: center" v-else>{{message['user_info']['name'].substring(0,5)}}...</span>
                                        <!--<span>{{message.up_time}}</span>-->
                                    </div>
                                    <div class="item_content_self">
                                        <div>
                                            <img class="item_side_img_right" :src="right_img">
                                            <i style="cursor: pointer" :class="is_teacher?'el-icon-close top_message_item_close':'not_show'" @click="delete_chat_message(message)"></i>
                                            {{message.message}}
                                            <button :class="is_teacher?'raise_btn_self':'not_show'" :data-outer-id="message['outer_id']"
                                                    @click="click_raise_btn($event)">
                                                置顶
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div v-else>
                                    <div class="item_header">
                                        <img class="avatar" :src="message['user_info']['avatar_url']">
                                        <span style="text-align: center" v-if="message['user_info']['name'].length <= 5">{{message['user_info']['name']}}</span>
                                        <span style="text-align: center" v-else>{{message['user_info']['name'].substring(0,5)}}...</span>
                                        <!--<span>{{message.up_time}}</span>-->
                                    </div>
                                    <div class="item_content"  :style="user_info.teacher.includes(Number(message['user_info']['user_id']))?'font-weight: bolder;color:#3B200C':'color:#3B200C'">
                                        <div>
                                            <img class="item_side_img" :src="left_img">
                                            {{message.message}}
                                            <button :class="is_teacher?'raise_btn':'not_show'" :data-outer-id="message['outer_id']"
                                                    @click="click_raise_btn($event)">
                                                置顶
                                            </button>
                                            <i style="cursor: pointer" :class="is_teacher?'el-icon-close top_message_item_close':'not_show'" @click="delete_chat_message(message)"></i>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>

                    <div :class="forbidden?'not_show':'input_area'">
                        <textarea placeholder="请在此输入..." maxlength="1000" v-if="is_symposium_opened" class="test_area" v-model="inputting_words"
                              v-on:keyup.13="websocketsend()"></textarea>
                        <textarea v-else class="test_area" v-model="inputting_words"></textarea>
                        <!--<input type="text" class="form-control" v-model="inputting_words">-->
                        <button v-if="(is_symposium_opened && !forbidden)|| is_teacher" class="btn_sym" @click="websocketsend()">
                            发送
                        </button>
                    </div>
                    <div :class="forbidden?'input_area':'not_show'">
                        <p style="color: red">您已被管理员禁言</p>
                    </div>
                </div>
            </div>
        </div>

        <div>

        </div>

    </div>
    <div v-else>
        <div v-if="is_teacher">
            <div :class="is_mobile?'not_access_page_div_mobile':'not_access_page_div'">
                <!--<img class="not_access_wrap_image" src="https://static.shiyanlou.com/frontend/dist/img/9692684.png">-->
                <div class="not_access_side">
                    <p class="text">
                        研讨会未开启，待开启后请重新进入该页面
                    </p>
                    <div>
                        <a v-if="is_teacher" class="back_to_home_button" @click="symposium_socket_open()">
                            开启研讨会
                        </a>
                        <a href="/" class="back_to_home_button">
                            返回首页
                        </a>
                        <a :href="'/courses/'+course_id" class="back_to_home_button">
                            返回课程
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <v-loader :source="is_teacher"></v-loader>
        </div>
    </div>
</template>

<script>
    import cookies from 'vue-cookies'
    import {mapState, mapActions} from 'vuex'
    import SymposiumApi from '@/api/symposium/symposium.js'
    import wx from 'weixin-js-sdk'
    export default {
        data() {
            return {
                path: '',
                websock: "",
                sock_keep: '',
                inputting_words: '',
                all_words: [],
                user_id: cookies.get('userId'),
                user_info: {},
                symposium_subject: [],//全部主题信息，正副标题，置顶消息
                all_up_message: [],//置顶信息列表
                active_page: {},
                all_user: [],
                dialogVisible: false,
                messageDialogVisible: false,
                subjectNameDialogVisible: false,
                subjectContentDialogVisible: false,
                usersDialogVisible: false,
                deleteDialogVisible: false,
                is_teacher: false,
                course_id: 0,
                course_name: '',
                is_socket_opened: false,//socket是否开启
                is_symposium_opened: false,//教师控制，开始结束研讨
                is_connected: false,//连接socket是否成功
                temp_outer_id: '',
                all_raise: [],
                all_raise_left_time: [],
                all_kanban: [],
                temp_long_word: '',
                temp_pack_count: 0,
                temp_pack: 0,
                long_word: false,
                temp_change_message: '',
                temp_change_message_old: '',
                temp_change_message_id: '',
                temp_subject_name: '',
                temp_subject_name_old: '',
                temp_subject_content: '',
                temp_subject_content_old: '',
                temp_subject_id: '',
                forbidden: false,
                show_types: [{'key': 0, 'value': '微信模式'}, {'key': 1, 'value': '看板模式'}],
                show_type : '微信模式',
                left_img:'/static/img/zuo.jpg',
                right_img:'/static/img/you.jpg',
                is_mobile: false,
                screen_height: {height: window.screen.height - 250 + 'px'},
                screen_height_mobile: {height: window.screen.height - 200 + 'px'},
                center_button_flow_left: {left: document.body.clientWidth * 0.6 - 230 + 'px'},
                center_button_flow_left_mobile: {left: document.body.clientWidth - 180 + 'px'},
                doc_width: document.body.clientWidth,
                delete_message_info: '',
                delete_message_message: '',
                timer1: null,
            }
        },
        created: function () {
            if (!this.sign_on) {
                this.change_show_state('on')
            } else {
                let that = this
                let courseId = this.$route.params.id
                if (this._isMobile()){
                    this.is_mobile = true
                }
                SymposiumApi.get_user_info(courseId).then(function (response) {
                    let resp = response.data
                    console.log(resp)
                    that.user_info = {'id': resp['id'], 'name': resp['name'], 'avatar_url': resp['avatar_url'], 'session_id':resp['session_id'], 'teacher': resp['teacher']}
                    that.course_id = response.data.course_id
                    that.course_name = response.data.course_name
                    if (response.data['is_ssl']){
                        that.path = "wss://" + response.data['path'] + '/' + resp['session_id']
                    }else{
                        that.path = "ws://" + response.data['path'] + '/' + resp['session_id']
                    }
                    console.log(that.path)
                    if (that.user_info.teacher.includes(Number(that.user_id))) {
                        that.is_teacher = true
                    }
                    that.is_socket_opened = response.data['is_socket_opened']
                    that.is_symposium_opened = response.data['is_symposium_opened']
                    if (that.is_socket_opened){
                        that.init()
                    }
                    // that.websock.send(JSON.stringify({'new': response}));
                })
            }
        },
        mounted: function() {
            setInterval(this.set_raise_time_by_seconds, 1000)
            window.onresize = () => {
                return (() => {
                  this.center_button_flow_left = {left: document.body.clientWidth * 0.6 - 150 + 'px'};
                  this.center_button_flow_left_mobile = {left: document.body.clientWidth - 100 + 'px'};
                })();
            };

        },
        beforeDestroy() {
            // 销毁监听
            this.websock.onclose()
        },
        computed: {
            ...mapState({
                sign_on: state => state.loginState.sign_on,
                // user_info: state => state.loginState.user_info,
                // user_name: state => state.loginState.user_info.name,
                // user_avatar_url: state => state.loginState.user_info.avatar_url,
            })
        },
        methods: {
            ...mapActions({
                change_show_state: 'loginState/change_show_state',
                change_user_info: 'loginState/change_user_info',
                change_warning_message: 'warningBar/change_message',
            }),
            _isMobile() {
              let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
              return flag;
            },
            handleTabsClick(tab, event){
                if (tab.name === 'back'){
                    this.$router.push({name: 'course', params: {id: this.course_id}})
                }
            },
            show_type_change(){
                console.log(this.show_type)
            },
            start_or_end_symposium(type){
                let lesson_id = this.$route.params.id
                let args = {
                    'lesson_id':lesson_id,
                    'type':type,
                }
                if (type === 'start'){
                    this.is_symposium_opened = true
                    this.websock.send(JSON.stringify({'start_or_end_symposium': args}))
                }else if (type === 'end'){
                    this.$confirm('是否现在下课?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(()=>{
                        this.is_symposium_opened = false
                        this.websock.send(JSON.stringify({'start_or_end_symposium': args}))
                    }).catch(()=>{
                        this.$message({
                            type: 'info',
                            message: '已取消'
                        });
                    })
                }
            },
            delete_chat_message(message){
                this.websock.send(JSON.stringify({'delete_chat_message': message}))
            },
            symposium_socket_open(){
                let lesson_id = this.$route.params.id
                let args = {
                    'lesson_id':lesson_id,
                }
                SymposiumApi.open_symposium_socket(args).then(function () {
                    location.reload()
                })
            },
            support_up_message(message) {
                this.websock.send(JSON.stringify({'support_up_message': message, 'is_support': true}))
            },
            stamp_up_message(message) {
                this.websock.send(JSON.stringify({'support_up_message': message, 'is_support': false}))
            },
            delete_up_message(message) {
                this.websock.send(JSON.stringify({'delete_up_message': 'delete_up_message', 'message': message}));
            },
            delete_up_message_comfirm() {
                let message = this.delete_message_info
                console.log(message)
                this.websock.send(JSON.stringify({'delete_up_message': 'delete_up_message', 'message': message}));
                this.deleteDialogVisible = false
            },
            delete_raise_message(message) {
                this.websock.send(JSON.stringify({'delete_raise_message': 'delete_raise_message', 'message': message}));
            },
            add_page() {
                this.websock.send(JSON.stringify({'add_page': 'add_page', 'user_id': this.user_id}));
            },
            drag_test(event){
                let outer_id = event.target.getAttribute('data-o-id')
                // this.delete_up_message_and_set_info(outer_id)
                console.log(outer_id)
            },
            drop(event){
                let outer_id = event.target.getAttribute('data-o-id')
                // this.delete_up_message_and_set_info(outer_id)
                console.log('drop', outer_id)
            },
            change_active_page(page) {
                this.active_page = page
                let lesson_id = this.$route.params.id
                let args = {
                    'lesson_id': lesson_id,
                    'page_id': page.outer_id,
                }
                this.websock.send(JSON.stringify({'change_page': args}));
            },
            change_subject(subject) {
                let page = subject['pages'][0]
                this.active_page = page
                let lesson_id = this.$route.params.id
                let args = {
                    'lesson_id': lesson_id,
                    'page_id': page.outer_id,
                }
                this.websock.send(JSON.stringify({'change_page': args}));
            },
            set_user_forbidden(user){
              if (user['forbidden']){
                  user['forbidden'] = false
                  this.websock.send(JSON.stringify({'set_user_forbidden': {'user_id': user['user_id'], 'forbidden': false}}));
              }else{
                  user['forbidden'] = true
                  this.websock.send(JSON.stringify({'set_user_forbidden': {'user_id': user['user_id'], 'forbidden': true}}));
              }
            },
            change_message_dialog_btn: function () {
                if (this.temp_change_message.match(/^[ ]*$/)){
                    this.$message({
                        message: '信息内容不可为空',
                        type: 'warning'
                    });
                    return
                }
                this.messageDialogVisible = false
                if (this.temp_change_message !== this.temp_change_message_old){
                    this.websock.send(JSON.stringify({'message_change': {'message_id': this.temp_change_message_id, 'message': this.temp_change_message}}));
                }
                this.temp_change_message = ''
                this.temp_change_message_old = ''
                this.temp_change_message_id = ''
            },
            subject_name_dialog_btn: function () {
                this.subjectNameDialogVisible = false
                if (this.temp_subject_name !== this.temp_subject_name_old){
                    console.log(this.temp_subject_name)
                    this.websock.send(JSON.stringify({'subject_name_change': {'subject_id': this.temp_subject_id, 'name': this.temp_subject_name}}));
                    // this.websock.send(JSON.stringify({'message_change': {'message_id': this.temp_change_message_id, 'message': this.temp_change_message}}));
                }
                this.temp_subject_name = ''
                this.temp_subject_name_old = ''
                this.temp_subject_id = ''
            },
            subject_content_dialog_btn: function () {
                this.subjectContentDialogVisible = false
                if (this.temp_subject_content !== this.temp_subject_content_old){
                    console.log(this.temp_subject_content)
                    this.websock.send(JSON.stringify({'subject_content_change': {'subject_id': this.temp_subject_id, 'content': this.temp_subject_content}}))
                }
                this.temp_subject_content = ''
                this.temp_subject_content_old = ''
                this.temp_subject_id = ''
            },
            click_dialog_btn: function (event) {
                let raise_time = event.target.getAttribute('data-time')
                this.dialogVisible = false
                if (raise_time !== '0') {
                    this.websock.send(JSON.stringify({'raise': {'outer_id': this.temp_outer_id, 'time': raise_time}}));
                }
                console.log(raise_time, this.temp_outer_id, 'raise_time')
            },
            click_raise_btn: function (event) {
                console.log('before', this.temp_outer_id)
                let outer_id = event.target.getAttribute('data-outer-id')
                this.temp_outer_id = outer_id
                this.dialogVisible = true
                console.log(outer_id, event, 'raise_time')
            },
            init: function () {
                if (typeof (WebSocket) === "undefined") {
                    alert("您的浏览器不支持socket")
                } else {
                    console.log('created')
                    // 实例化socket
                    let that = this
                    // this.websock = new WebSocket(this.path)
                    // this.websock.onmessage = this.websocketonmessage;
                    // this.websock.onopen = this.websocketonopen;
                    // this.websock.onerror = this.websocketonerror;
                    // this.websock.onclose = this.websocketclose;
                    setTimeout(()=>{
                        that.websock = new WebSocket(that.path)
                        that.websock.onmessage = that.websocketonmessage;
                        that.websock.onopen = that.websocketonopen;
                        that.websock.onerror = that.websocketonerror;
                        that.websock.onclose = that.websocketclose;
                    }, 1000)
                    // setInterval(function(){
                    //     console.log('create new ws')
                    //     that.websock = new WebSocket(that.path)
                    // },1000)

                }
            },
            websocketonopen() { //连接建立之后执行send方法发送数据
                console.log('连接成功',);
                this.is_connected = true
                this.websocketnewuser();
            },
            websocketonerror() {//连接建立失败重连
                console.log('连接出错');
                this.is_connected = false
                // this.websock.send(JSON.stringify({'quit': 'quit'}))
                this.init();
            },
            websocketonmessage(e) { //数据接收
                // const redata = JSON.parse(e.data);
                // console.log('收到信息', e.data)
                let res = JSON.parse(e.data)
                if (res['type'] === 'format_long') {
                    // console.log('get long format info', res)
                    if (res['pack'] === 1){
                        this.temp_pack_count = res['pack_count']
                        this.temp_pack = res['pack']
                        this.temp_long_word = res['strings']
                        this.long_word = true
                    }else{
                        this.temp_pack = res['pack']
                        // console.log('before',this.temp_long_word.length)
                        this.temp_long_word += res['strings']
                        // console.log('after',this.temp_long_word.length)
                    }
                    // console.log('long word', this.temp_pack, this.temp_pack_count, this.temp_long_word.length)
                    if (this.temp_pack === this.temp_pack_count){
                        this.long_word = false
                        // console.log('get long word',this.temp_long_word)
                        let temp = JSON.parse(this.temp_long_word)
                        this.temp_long_word = ''
                        // console.log('get long word', temp)
                        this.call_set_items(temp)
                    }
                }else{
                    this.call_set_items(res)
                }
            },
            call_set_items(res){
                if (res['type'] === 'new_user') {
                    this.all_user = res['data']
                    console.log('new_user', res['data'])
                } else if (res['type'] === 'raise') {
                    console.log(res['message'])
                    this.set_raise_info(res['message'])
                    if (res['page_msgs'] !== 'not_set') {
                        this.set_up_message_to_subject_and_set_info(res['page_msgs'])
                    }
                } else if (res['type'] === 'format') {
                    let lesson_id = this.$route.params.id
                    console.log('get format info', JSON.stringify(res))
                    this.symposium_subject = res['subjects']
                    this.set_current_page_and_info(res['subjects'])
                    this.set_raise_info(res['message'])
                    this.set_all_words(res['all_messages'],lesson_id)
                    setTimeout(function () {
                        let div = document.getElementById('scroll_div');
                        div.scrollTop = div.scrollHeight;
                    }, 200)
                }
                // else if (res['quit'] === 'quit'){
                //     this.websock.send(JSON.stringify({'quit': 'quit'}));
                // }
                else if (res['type'] === 'symposium_opened') {
                    this.is_symposium_opened = true
                }
                else if (res['type'] === 'symposium_closed') {
                    this.is_symposium_opened = false
                }
                else if (res['type'] === 'set_forbidden') {
                    this.forbidden = res['forbidden']
                }
                else if (res['type'] === 'subject_name_change') {
                    let subject_id = res['subject_id']
                    let name = res['name']
                    this.subject_name_changed(subject_id, name)
                    // this.set_support_or_stamp(m_id, is_support)
                }
                else if (res['type'] === 'subject_content_change') {
                    let subject_id = res['subject_id']
                    let content = res['content']
                    this.subject_content_changed(subject_id, content)
                    // this.set_support_or_stamp(m_id, is_support)
                }
                else if (res['type'] === 'support_up_message') {
                    let m_id = res['message_id']
                    let is_support = res['is_support']
                    let is_reset = res['is_reset']
                    this.set_support_or_stamp(m_id, is_support,is_reset)
                }
                else if (res['type'] === 'message_change') {
                    let m_id = res['message_id']
                    let message = res['message']
                    console.log('message_change', message, m_id)
                    this.change_message_info(m_id, message)
                }
                else if (res['type'] === 'support_fail') {
                    this.change_warning_message('已经为该内容点过赞或点过踩')
                }
                else if (res['type'] === 'change_page') {
                    console.log('get change_page', res['page'])
                    this.set_current_page_and_info_by_page(res['page'])
                }
                else if (res['type'] === 'add_page') {
                    console.log('add_page', res['subjects'], res['subject'])
                    this.add_subject(res['subject'])
                }
                else if (res['type'] === 'delete_up_message') {
                    console.log('delete_up_message', res['message_id'])
                    this.delete_up_message_and_set_info(res['message_id'])
                }
                else if (res['type'] === 'delete_chat_message'){
                    console.log('delete_chat_message', res['message_outer_id'])
                    this.delete_chat_message_by_outer_id(res['message_outer_id'])
                }
                else if (res['type'] === 'delete_raise_message') {
                    console.log('delete_raise_message', res['messages'])
                    this.set_raise_info(res['messages'])
                }
                else {
                    this.all_words.push(res)
                    setTimeout(function () {
                        let div = document.getElementById('scroll_div');
                        div.scrollTop = div.scrollHeight;
                    }, 200)
                    console.log('on message', this.all_words)
                }
            },
            websocketsend() {//数据发送
                if (this.inputting_words !== '' && !this.forbidden) {
                    this.websock.send(JSON.stringify({'message': this.inputting_words}));
                    this.inputting_words = ''
                }
            },
            websocketnewuser() {//新用户发送user_id
                // let that = this
                // let courseId = this.$route.params.id
                console.log(this.user_info)
                this.websock.send(JSON.stringify({'new': {'data': this.user_info}}));
                // SymposiumApi.get_user_info(courseId).then(function (response) {
                //     console.log('new user', response)
                //     that.websock.send(JSON.stringify({'new': response}));
                // })
                // let actions = {"new": {'user_id': this.user_id, 'avatar_url': this.user_info.avatar_url,'name': this.user_info.name}};
                // console.log(actions)
                // this.websock.send(JSON.stringify(actions));
            },
            websocketclose(e) {  //关闭
                // this.websock.send('quit')
                // this.websock.send(JSON.stringify({'quit': 'quit'}))
                console.log('断开连接', e);
            },
            delete_chat_message_by_outer_id(outer_id){
                let temp = -1
                for (let i=0; i<this.all_words.length; i++){
                    if (outer_id === this.all_words[i]['outer_id']){
                        temp = i
                        break
                    }
                }
                if (temp !== -1){
                    this.all_words.splice(temp,1)
                    this.delete_up_message_and_set_info(outer_id)
                }
                setTimeout(function () {
                    let div = document.getElementById('scroll_div');
                    div.scrollTop = div.scrollHeight;
                }, 200)
            },
            set_all_up_message(res){
                for (let i = 0; i < res.length; i++) {
                    let msg = res[i]['message']
                    if (msg.length >= 101){
                        res[i]['title'] = msg.slice(0, 100) + '...'
                    }else{
                        res[i]['title'] = msg
                    }
                }
                this.all_up_message = res
                setTimeout(function () {
                    let div = document.getElementById('root_center');
                    div.scrollTop = div.scrollHeight;
                }, 200)
            },
            set_raise_info(res) {
                if(res){
                    for(let i = 0; i < res.length; i++) {
                        if(res[i]['message'].length >= 21) {
                            let msg = res[i]['message']
                            res[i]['title'] = msg.slice(0, 20) + '...'
                        }else{
                            res[i]['title'] = res[i]['message']
                        }
                    }
                    res = this.calc_date_for_raise(res)
                }
                console.log('raise', res)
                this.all_raise = res
                // setInterval(this.get_time_left(res[0]['seconds_left']), 1000);
            },
            set_all_words(all_messages, lesson_id){
                // this.all_words = all_messages
                let list = []
                all_messages.forEach((item)=>{
                    list.push({
                        lesson_id: lesson_id,
                        message: item.message,
                        outer_id: item.outer_id,
                        time: item.up_time,
                        type: 'message',
                        user_info: {
                            avatar_url: item['user']?item['user']['avatar_url']:item['user_info']?item['user_info']['avatar_url']:'',
                            forbidden: false,
                            name: item['user']?item['user']['name']:item['user_info']?item['user_info']['name']:'',
                            user_id: item['user']?item['user']['id']:item['user_info']?item['user_info']['user_id']:'',
                        }
                    })
                })
                this.all_words = list
            },
            calc_date_for_raise(messages){
                let new_list = []
                let all_raise_left_time = []
                for (let i = 0; i < messages.length; i++) {
                    let now_time = messages[i]['now_time']
                    let data = new Date()
                    let that_data = new Date(data.getFullYear() + '/' + (data.getMonth()+1) + '/' + data.getDate() + ' ' + now_time)
                    let raise_time = Number(messages[i]['raise_time'])
                    if (raise_time !== -1){
                        raise_time = raise_time * 60
                        let time_left = raise_time - Math.floor((data- that_data)/1000)
                        if (time_left > 0){
                            messages[i]['seconds_left'] = time_left
                            all_raise_left_time.push(time_left)
                            new_list.push(messages[i])
                        }
                    }else{
                        messages[i]['seconds_left'] = -1
                        all_raise_left_time.push(-1)
                        new_list.push(messages[i])
                    }
                    console.log(that_data, data)
                }
                console.log(new_list,all_raise_left_time)
                new_list.sort(function (a, b) {
                    if (a['seconds_left'] === -1 && b['seconds_left'] === -1){
                        return -1
                    }else if (b['seconds_left'] === -1){
                        return 1
                    }else if (a['seconds_left'] === -1){
                        return -1
                    }else{
                        return b['seconds_left'] - a['seconds_left']
                    }
                })
                all_raise_left_time.sort(function (a, b) {
                    if (a === -1 && b === -1){
                        return -1
                    }else if (b === -1){
                        return 1
                    }else if (a === -1){
                        return -1
                    }else{
                        return b - a
                    }
                })
                console.log(new_list,all_raise_left_time)
                this.all_raise_left_time = all_raise_left_time
                return new_list
            },
            set_raise_time_by_seconds(){
                let list = []
                if (this.all_raise_left_time){
                    for (let i = 0; i < this.all_raise_left_time.length; i++){
                        if (this.all_raise_left_time[i] !== -1){
                            this.all_raise_left_time[i] = this.all_raise_left_time[i] - 1
                            if (this.all_raise_left_time[i] > 0){
                                list.push(this.all_raise_left_time[i])
                            }else{
                                this.all_raise.splice(i, 1)
                            }
                        }else {
                            list.push(this.all_raise_left_time[i])
                        }
                    }
                    this.all_raise_left_time = list
                }
            },
            set_current_page_and_info(subjects){
                if (subjects) {
                    for (let i = 0; i < subjects.length; i++) {
                        for (let x = 0; x < subjects[i]['pages'].length; x++) {
                            if (subjects[i]['pages'][x]['is_current']) {
                                this.active_page = subjects[i]['pages'][x]
                                this.set_all_up_message(subjects[i]['pages'][x]['m_ids'])
                            }
                        }
                    }
                }
            },
            set_up_message_to_subject_and_set_info(message){
                if (this.symposium_subject) {
                    let obj = this.symposium_subject
                    for (let i = 0; i < obj.length; i++) {
                        for (let x = 0; x < obj[i]['pages'].length; x++) {
                            if (obj[i]['pages'][x]['is_current']) {
                                let is_set = true
                                for (let z = 0; z < obj[i]['pages'][x]['m_ids'].length; z++){
                                    if (obj[i]['pages'][x]['m_ids'][z]['outer_id'] == message['outer_id']){
                                        is_set = false
                                    }
                                }
                                if (is_set){
                                    obj[i]['pages'][x]['m_ids'].push(message)
                                    this.set_all_up_message(obj[i]['pages'][x]['m_ids'])
                                }
                            }
                        }
                    }
                }
            },
            delete_up_message_and_set_info(message_id){
                if (this.symposium_subject) {
                    let obj = this.symposium_subject
                    for (let i = 0; i < obj.length; i++) {
                        for (let x = 0; x < obj[i]['pages'].length; x++) {
                            let temp = -1
                            for (let z = 0; z < obj[i]['pages'][x]['m_ids'].length; z++) {
                                if(obj[i]['pages'][x]['m_ids'][z]['outer_id'] === message_id){
                                    temp = z
                                }
                            }
                            if (temp !== -1){
                                obj[i]['pages'][x]['m_ids'].splice(temp,1)
                                this.active_page = obj[i]['pages'][x]
                                this.set_all_up_message(obj[i]['pages'][x]['m_ids'])
                            }
                        }
                    }
                }
            },
            set_current_page_and_info_by_page(page_id){
                console.log(this.symposium_subject, page_id)
                if (this.symposium_subject) {
                    for (let i = 0; i < this.symposium_subject.length; i++) {
                        for (let x = 0; x < this.symposium_subject[i]['pages'].length; x++) {
                            if (this.symposium_subject[i]['pages'][x]['outer_id'] === page_id) {
                                console.log(this.symposium_subject[i]['pages'][x], page_id)
                                this.symposium_subject[i]['pages'][x]['is_current'] = true
                                this.active_page = this.symposium_subject[i]['pages'][x]
                                this.set_all_up_message(this.symposium_subject[i]['pages'][x]['m_ids'])
                            }else{
                                this.symposium_subject[i]['pages'][x]['is_current'] = false
                            }
                        }
                    }
                }
            },
            add_page_to_subjects(page){
                if (this.symposium_subject) {
                    var obj = Object.create(this.symposium_subject)
                    for (let i = 0; i < obj.length; i++) {
                        if (page['subject_id'] === obj[i]['id']){
                            obj[i]['pages'].push(page)
                        }
                    }
                    this.symposium_subject = obj
                }
            },
            add_subject(subject){
                console.log('in add sub', subject)
                if (this.symposium_subject) {
                    // var obj = Object.create(this.symposium_subject)
                    for (let i = 0; i < this.symposium_subject.length; i++) {
                        for (let x = 0; x < this.symposium_subject[i]['pages'].length; x++) {
                            if (this.symposium_subject[i]['pages'][x]['is_current']) {
                                this.symposium_subject[i]['pages'][x]['is_current'] = false
                                console.log('old current page', this.symposium_subject[i]['pages'][x])
                            }
                        }
                    }
                    this.symposium_subject.push(subject)
                    console.log(JSON.stringify(this.symposium_subject))
                    // this.symposium_subject = obj
                    this.active_page = subject['pages'][0]
                    this.set_all_up_message(subject['pages'][0]['m_ids'])
                }
            },
            set_support_or_stamp(message_id, is_support, is_reset) {
                // for (let i = 0; i < this.all_up_message.length; i++){
                //     if (this.all_up_message[i]['outer_id'] === message_id){
                //         var obj = Object.create(this.all_up_message)
                //         if (is_support){
                //             obj[i]['support_count'] += 1
                //         }else{
                //             obj[i]['stamp_count'] += 1
                //         }
                //         this.all_up_message = obj
                //     }
                // }
                if (this.symposium_subject) {
                    for (let i = 0; i < this.symposium_subject.length; i++) {
                        for (let x = 0; x < this.symposium_subject[i]['pages'].length; x++) {
                            for (let z = 0; z < this.symposium_subject[i]['pages'][x]['m_ids'].length; z++){
                                if (this.symposium_subject[i]['pages'][x]['m_ids'][z]['outer_id'] === message_id){
                                    if (is_support){
                                        if (is_reset){
                                            this.symposium_subject[i]['pages'][x]['m_ids'][z]['support_count'] += 1
                                            this.symposium_subject[i]['pages'][x]['m_ids'][z]['stamp_count'] -= 1
                                        }else{
                                            this.symposium_subject[i]['pages'][x]['m_ids'][z]['support_count'] += 1
                                        }
                                    }else{
                                        if (is_reset){
                                            this.symposium_subject[i]['pages'][x]['m_ids'][z]['stamp_count'] += 1
                                            this.symposium_subject[i]['pages'][x]['m_ids'][z]['support_count'] -= 1
                                        }else{
                                            this.symposium_subject[i]['pages'][x]['m_ids'][z]['stamp_count'] += 1
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            },
            change_message_info(message_id, message) {
                for (let i = 0; i < this.all_up_message.length; i++){
                    if (this.all_up_message[i]['outer_id'] === message_id){
                        let obj = Object.create(this.all_up_message)
                        obj[i]['message'] = message
                        this.all_up_message = obj
                    }
                }
                if (this.symposium_subject) {
                    for (let i = 0; i < this.symposium_subject.length; i++) {
                        for (let x = 0; x < this.symposium_subject[i]['pages'].length; x++) {
                            for (let z = 0; z < this.symposium_subject[i]['pages'][x]['m_ids'].length; z++){
                                if (this.symposium_subject[i]['pages'][x]['m_ids'][z]['outer_id'] === message_id){
                                    this.symposium_subject[i]['pages'][x]['m_ids'][z]['message'] = message
                                }
                            }
                        }
                    }
                }
            },
            subject_name_change(event){
                if (this.symposium_subject) {
                    let obj = this.symposium_subject
                    for (let i = 0; i < obj.length; i++) {
                        for (let x = 0; x < obj[i]['pages'].length; x++) {
                            console.log(obj[i]['pages'][x]['is_current'], obj[i]['outer_id'])
                            if (obj[i]['pages'][x]['is_current'] && event.target.value !== event.target._value) {
                                let subject_id = obj[i]['outer_id']
                                console.log('subject:', obj[i]['name'], '改名为：', event.target.value)
                                this.websock.send(JSON.stringify({'subject_name_change': {'subject_id': subject_id, 'name': event.target.value}}));
                            }
                        }
                    }
                }
            },
            subject_content_change(event){
                if (this.symposium_subject) {
                    let obj = this.symposium_subject
                    for (let i = 0; i < obj.length; i++) {
                        for (let x = 0; x < obj[i]['pages'].length; x++) {
                            if (obj[i]['pages'][x]['is_current'] && event.target.value !== event.target._value) {
                                let subject_id = obj[i]['id']
                                console.log('subject:', obj[i]['name'], '内容为：', event.target.value)
                                this.websock.send(JSON.stringify({'subject_content_change': {'subject_id': subject_id, 'content': event.target.value}}));
                            }
                        }
                    }
                }
            },
            subject_name_changed(subject_id, name){
                if (this.symposium_subject) {
                    let obj = Object.create(this.symposium_subject)
                    for (let i = 0; i < obj.length; i++) {
                        if (obj[i]['outer_id'] === subject_id){
                            console.log('subject:', obj[i]['name'], '已改名为：', name)
                            obj[i]['name'] = name
                            for (let z = 0; z < obj[i]['pages'].length; z++){
                                obj[i]['pages'][z]['subject_name'] = name
                            }
                        }
                    }
                    this.symposium_subject = obj
                }
                if (this.active_page){
                    let page = Object.create(this.active_page)
                    page['subject_name'] = name
                    this.active_page = page
                }
            },
            subject_content_changed(subject_id, content){
                if (this.symposium_subject) {
                    let obj = Object.create(this.symposium_subject)
                    for (let i = 0; i < obj.length; i++) {
                        if (obj[i]['id'] === subject_id){
                            console.log('subject:', obj[i]['content'], '已改内容为：', content)
                            obj[i]['content'] = content
                            for (let z = 0; z < obj[i]['pages'].length; z++){
                                obj[i]['pages'][z]['content'] = content
                            }
                        }
                    }
                    this.symposium_subject = obj
                }
                if (this.active_page){
                    let page = Object.create(this.active_page)
                    page['content'] = content
                    this.active_page = page
                }
            },
            change_subject_name_dialog_on(){
                console.log(this.active_page)
                this.subjectNameDialogVisible = true
                this.temp_subject_name = this.active_page.subject_name
                this.temp_subject_name_old = this.active_page.subject_name
                this.temp_subject_id = this.active_page.subject_outer_id
            },
            change_subject_content_dialog_on(){
                console.log(this.active_page)
                this.subjectContentDialogVisible = true
                this.temp_subject_content = this.active_page.content
                this.temp_subject_content_old = this.active_page.content
                this.temp_subject_id = this.active_page.subject_outer_id
            },
            change_message_dialog_on(message){
                console.log(message.message)
                this.messageDialogVisible = true
                this.temp_change_message = message.message
                this.temp_change_message_old = message.message
                this.temp_change_message_id = message.outer_id
            },
            item_div_mouse_in(event){
                let el = event.target
                if (el.className === 'item significant_kanban' || el.className === 'item_center significant_kanban'){
                    // el.children[0].children[1].children[1].style.display = 'inline-flex'
                    if (this.is_teacher){
                        el.children[0].children[2].style.display = 'inline-flex'
                    }
                }
            },
            item_div_mouse_leave(event){
                let el = event.target
                if (el.className === 'item significant_kanban' || el.className === 'item_center significant_kanban'){
                    // el.children[0].children[1].children[1].style.display = 'none'
                    if (this.is_teacher){
                        el.children[0].children[2].style.display = 'none'
                    }
                }
            },
            get_time_left(all_seconds){
                let res = '永久'
                if (all_seconds !== -1) {
                    let hours = Math.floor(all_seconds / (60 * 60))
                    let minutesLevel = all_seconds % (60 * 60);
                    let minutes = Math.floor(minutesLevel / (60));
                    let seconds = Math.round(minutesLevel % 60);
                    if (hours){
                        res = hours + ":" + minutes + ":" + seconds
                    }else{
                        res = minutes + ":" + seconds
                    }
                }
                return res
            },
            up_message_on_mouse_down(event,e){
                event.preventDefault()
                let message = JSON.parse(JSON.stringify(e))
                let that = this
                this.timer1 = setTimeout(function () {
                    that.delete_message_info = message
                    that.deleteDialogVisible = true
                }, 600);
            },
            up_message_on_mouse_move(){
                if (this.timer1){
                    clearTimeout(this.timer1);
                    this.timer1 = false
                }
            },
            up_message_on_mouse_up(){
                if (this.timer1){
                    clearTimeout(this.timer1);
                    this.timer1 = false
                }
            },
            click_quit(){
                if(window.__wxjs_environment === 'miniprogram'){
                    wx.miniProgram.navigateTo({url: '/pages/course/index?id='+this.course_id})
                }else{
                    this.$router.push({ name: 'course',params: { id: this.course_id }})
                }
            },
            //获取当前页面的缩放值
            detectZoom() {
                var ratio = 0,
                    screen = window.screen,
                    ua = navigator.userAgent.toLowerCase();

                if (window.devicePixelRatio !== undefined) {
                    ratio = window.devicePixelRatio;
                }
                else if (~ua.indexOf('msie')) {
                    if (screen.deviceXDPI && screen.logicalXDPI) {
                        ratio = screen.deviceXDPI / screen.logicalXDPI;
                    }
                }
                else if (window.outerWidth !== undefined && window.innerWidth !== undefined) {
                    ratio = window.outerWidth / window.innerWidth;
                }
                if (ratio) {
                    ratio = Math.round(ratio * 100);
                }
                return ratio;
            },
        },
        watch: {
            sign_on: function () {
                if (this.sign_on) {
                    this.websocketnewuser()
                }
            },
            all_raise: function () {
                let div = document.getElementById('scroll_div');
                let ratio = this.detectZoom()
                if (ratio!== 0){
                    div.style.height = String(100-this.all_raise.length*8.6*this.detectZoom()/100) + '%'
                }else{
                    div.style.height = String(100-this.all_raise.length*8.6) + '%'
                }
            },
            doc_width: function () {
                this.center_button_flow_left = {left: document.body.clientWidth * 0.6 - 230 + 'px'}
                this.center_button_flow_left_mobile = {left: document.body.clientWidth - 180 + 'px'}
            },
        },
    }
</script>

<style scoped>
    .item_close {
        position: absolute;
        right: 0px;
        top: 0px;
    }
    .item_close_mobile {
        position: absolute;
        right: 8px;
        top: 0px;
    }

    .item_up {
        position: absolute;
        bottom: -10px;
        right: 40px;
        width: 40px;
    }

    .item_down {
        position: absolute;
        bottom: -10px;
        right: 0px;
        width: 40px;
    }

    .item_up_kanban {
        position: absolute;
        bottom: 10px;
        right: 45px;
    }

    .item_down_kanban {
        position: absolute;
        bottom: 10px;
        right: 5px;
    }

    #root {
        margin: 0 auto;
        width: 100%;
        column-count: 4;
        column-width: 200px;
        column-gap: 10px;
    }

    #root_center {
        margin: 0 auto;
        height: 85%;
        width: 100%;
        overflow-y: scroll;
        background: #fff;
    }
    .item_kanban{
        margin-bottom: 10px;
        padding: 10px 10px 10px 10px;
        break-inside: avoid;
        position: relative;
        min-height: 70px;
        background: #fff;
    }
    /* 每一列图片包含层 */
    .item {
        /* 防止多列布局，分页媒体和多区域上下文中的意外中断 */
        break-inside: avoid;
        position: relative;
        min-height: 20px;
        display: flow-root;
        /*background: #fff;*/
        list-style: none;
        margin: 0;
        padding: 0;
    }    /* 每一列图片包含层 */
    .item_center {
        /* 防止多列布局，分页媒体和多区域上下文中的意外中断 */
        break-inside: avoid;
        position: relative;
        border-bottom: 1px solid #eee;
        min-height: 20px;
        display: flow-root;
        /*background: #fff;*/
        list-style: none;
        margin: 0;
        padding: 0;
    }
    .item_content_kanban {
        margin-bottom: 10px;
        word-break: break-all;
    }
    .item_content {
        width: auto;
        word-break: break-all;
        background: #eeeeee;
        padding: 5px 20px;
        margin: 4px;
        line-height: 20px;
        font-size: 14px;
        border-radius: 10px;
        margin-left: 10px;
        position: relative;
        float: left;
        max-width: 80%;
    }
    .item_content_self {
        width: auto;
        word-break: break-all;
        background: #66ee41;
        padding: 5px 20px;
        margin: 4px;
        line-height: 20px;
        font-size: 14px;
        border-radius: 10px;
        margin-left: 10px;
        position: relative;
        float: right;
        max-width: 80%;
    }
    .item_content_mobile {
        width: auto;
        word-break: break-all;
        background: #eeeeee;
        padding: 5px 20px;
        margin: 4px;
        line-height: 20px;
        font-size: 14px;
        border-radius: 10px;
        margin-left: 10px;
        position: relative;
        float: left;
        max-width: 75%;
    }
    .item_content_self_mobile {
        width: auto;
        word-break: break-all;
        background: #66ee41;
        padding: 2px 10px;
        margin: 4px;
        line-height: 20px;
        font-size: 14px;
        border-radius: 10px;
        margin-left: 10px;
        position: relative;
        float: right;
        max-width: 75%;
    }
    .item_header{
        width: 32px;
        height: 44px;
        border-radius: 50%;
        margin-left: 15px;
        float: left;
        font-size: 2mm;
        align-items: center;
        text-align: center;
    }
    .item_header_self{
        width: 44px;
        height: 44px;
        border-radius: 50%;
        margin-left: 15px;
        float: right;
        font-size: 2mm;
        align-items: center;
        text-align: center;
    }
    .item_side_img{
        position: absolute;
        right: 100%;
        top: 8px;
        width: 12px;
        height: 12px;
    }
    .item_side_img_right{
        position: absolute;
        left: 100%;
        top: 8px;
        width: 12px;
        height: 12px;
    }
    .item_up_down_div{
        width: 15px;
        height: 0px;
        display: inline-flex;
        position: absolute;
        bottom: 2px;
    }
    .item_up_down_div_self{
        width: 60px;
        height: 0px;
        display: none;
        position: absolute;
    }
    .avatar {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        margin-right: 10px;
        padding-bottom: 1px;
        padding-top: 1px;
    }

    .message {
        background-color: white;
        border-bottom: 1px solid #eee;
        padding: 5px;
        word-break: break-all;
    }
    .message_center_left {
        word-break: break-all;
        padding: 5px 20px;
        margin: 4px;
        line-height: 20px;
        font-size: 14px;
        border-radius: 10px;
        margin-left: 10px;
        position: relative;
        float: left;
        max-width: 90%;
    }
    .message_center_left_mobile {
        word-break: break-all;
        padding: 5px 20px;
        margin: 5px;
        line-height: 20px;
        font-size: 14px;
        border-radius: 10px;
        margin-left: 10px;
        position: relative;
        float: left;
        max-width: 80%;
    }
    .message_center_right {
        word-break: break-all;
        padding: 5px 20px;
        margin: 4px;
        line-height: 20px;
        font-size: 14px;
        border-radius: 10px;
        margin-left: 10px;
        position: relative;
        float: right;
        max-width: 90%;
    }

    .close_btn_img {
        width: 20px;
        height: 20px;
    }

    .raise_btn {
        border: none;
        margin-right: 20px;
        margin-left: 20px;
        float: right;
        bottom: 10px;
        right: 20px;
        color: #12141d;
        width: 30px;
        height: 20px;
    }
    .raise_btn_self {
        border: none;
        margin-right: 20px;
        margin-left: 20px;
        float: left;
        bottom: 10px;
        right: 20px;
        color: #12141d;
        width: 30px;
        height: 20px;
    }
    .raise_btn_mobile {
        border: none;
        margin-right: 20px;
        float: right;
        bottom: 10px;
        right: 20px;
        color: #12141d;
        background: #e5edff;
        width: 30px;
        height: 30px;
    }
    .raise_btn_self_mobile {
        border: none;
        margin-right: 20px;
        float: left;
        bottom: 10px;
        right: 20px;
        color: #12141d;
        background: #e5edff;
        width: 30px;
        height: 30px;
    }
    .router-link-active{
        background-color: #ede387;
    }


    .top_message {
        background-color: #ea5e00;
        padding: 5px;
        border-bottom: 1px solid #eee;
        position: relative;
    }

    .top_message_item_close {
        position: absolute;
        top: 0px;
        right: 0px;
    }

    .test_area {
        width: 100%;
        height: 15%;
        outline: none;
        resize: none;
        /*border: 1px solid #DE8100;*/
        border-top: 1px solid #eee;
        border-left: 0;
        border-right: 0;
        border-bottom: 0;
        position: absolute;
        bottom: 0px;
    }
    .input_area {
        height: 15%;
    }

    .btn_sym {
        width: 68px;
        height: 25px;
        background: #ede387;
        border: none;
        position: absolute;
        bottom: 10px;
        right: 20px;
        color: #3B200C;
    }

    .close_btn {
        border: none;
        margin-right: 20px;
        float: right;
        bottom: 10px;
        right: 20px;
        /*color: white;*/
    }

    .dialog_btn {
        display: inline-block;
        line-height: 1;
        white-space: nowrap;
        cursor: pointer;
        background: #FFF;
        border: 1px solid #DCDFE6;
        color: #606266;
        -webkit-appearance: none;
        text-align: center;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        outline: 0;
        margin: 0;
        -webkit-transition: .1s;
        transition: .1s;
        font-weight: 500;
        padding: 12px 20px;
        font-size: 14px;
        border-radius: 4px;
        margin-bottom: 10px;
        margin-top: 10px;
    }

    .right_area {
        width: 30%;
        position: relative;
        border: 1px solid #DE8100;
    }
    .right_area_mobile {
        width: 100%;
        position: relative;
        /*border: 1px solid #DE8100;*/
    }
    .dialog_text{
        width: 100%;
        height: 300px;
    }

    .left_area {
        width: 8%;
        margin-left: 20px;
        margin-right: 20px;
        background-color: #fff;
        border-radius: 6px;
    }

    .center_area_mobile {
        width: 100%;
        padding: 20px;
        margin-right: 20px;
        /*border: 1px solid #DE8100;*/
    }
    .center_area {
        width: 60%;
        padding: 20px;
        margin-right: 20px;
        border: 1px solid #DE8100;
    }

    .center_area_not_teacher {
        width: 68%;
        padding: 20px;
        margin-right: 20px;
        border: 1px solid #DE8100;
    }

    .message_box {
        height: 90%;
        overflow-y: scroll;
        background: #fff;
    }

    .right_top_div {
        margin-bottom: 10px;
        padding-bottom: 10px;
        border-bottom: 1px solid #eee;
    }

    .not_show {
        display: none;
    }
    .show_flex {
        display: flex;
    }


    .not_access_page_div {
        width: 1170px;
        padding: 30px;
        padding-top: 150px;
        margin: auto;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .not_access_page_div_mobile {
        width: auto;
        padding: 30px;
        padding-top: 150px;
        margin: auto;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .not_access_wrap_image {
        width: 300px;
        margin-right: 100px;
    }

    .not_access_side {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    }

    .not_access_side_404 {
        width: 150px;
    }

    .text {
        padding: 30px 0;
        color: #666;
        font-size: 20px;
        margin: 0;
    }

    .back_to_home_button {
        color: #fff;
        border-color: #66CCFF;
        background-color: #66CCFF;
        border: 1px solid transparent;
        padding: .375rem .75rem;
        font-size: 1rem;
        line-height: 1.5;
        margin: 10px;
        border-radius: .25rem;
        transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
    }

    .back_to_home_button:hover {
        color: #fff;
        border-color: #069a75;
        background-color: #069a75;;
    }
    .tpl-left-nav-menu-sy{
        display: inline-block;
    }
    .tpl-left-nav-menu-sy-mobile{
        display: block;
    }

</style>